import React from 'react';
import Image from '../../../components/image';
import './team.scss';
import IconLinkedin from '../../../images/icon-linkedin.svg';
import IconXing from '../../../images/icon-xing.svg';

export const Member = (props) => {
	return (
		// <div className={`child ${count}`}>
		// 	<div className='image'>
		// 		<Image src={image} />
		// 	</div>
		// </div>

		<div className='image'>
			<Image src={`${props.image}`} />
		</div>
	);
};

export const MemberDetails = ({ name, bio, text, linkedin, xing }) => {
	return (
		// <div className={`child ${count}`}>
		// 	<div className='image'>
		// 		<Image src={image} />
		// 	</div>
		// </div>

		<div className='details'>
			<div className='head'>
				<h3>{name}</h3>
				<h4>{bio}</h4>
				<div className='socials'>
					<a href={linkedin} target='_blank'>
						<img src={IconLinkedin} />
					</a>
					<a href={xing} target='_blank'>
						<img src={IconXing} />
					</a>
				</div>
			</div>
			<p>{text}</p>
		</div>
	);
};
